import { store } from '../../../../../../store/store';
import actions from '../actions';
export const updateLocationForManageUsers = ({ institutionMemberId }) => (locationId) => {
    const action = actions.updateLocationForManageUsers({
        institutionMemberId,
        locationId,
    });
    store.dispatch(action);
};
